import { z } from "zod";
import { participantAssumptionsSchema } from "./participant-assumptions.schemas.js";

/**
 * A participant's assumption block for the admin inspector
 * (`GET /api/v1/admin/events/:eventIdPublic/participants/:participantIdPublic/assumptions`).
 *
 * The domain block crosses the wire as-is: it carries no secrets, and every
 * field on it — statement, confidence, category, status, origin — is exactly
 * what the admin needs to read. `null` when the participant has never had
 * assumptions generated.
 */
export const AdminParticipantAssumptionsSchema = z.object({
  assumptions: participantAssumptionsSchema.nullable(),
});

export type AdminParticipantAssumptions = z.infer<
  typeof AdminParticipantAssumptionsSchema
>;
